<div class="hotel-t-content" style="position: relative" [ngStyle]="{ 'margin-bottom': componentResults ? '145px' : '35px' }">
  <div *ngIf="componentResults" class="d-flex justify-content-between align-items-center mb-4 mt-3">
    <div class="d-flex align-items-center" style="gap: 1em">
      <ng-container *ngIf="idActivity === 6">
        <img src="../../../../../assets/img/app/categories-search-box/road-map.svg" style="width: 26px" alt="" />
        <h3 class="mb-0" style="font-family: &quot;Rubik&quot;, serif">Editar búsqueda de experiencia</h3>
      </ng-container>
      <ng-container *ngIf="idActivity === 9">
        <img src="../../../../../assets/img/app/categories-search-box/combi-ticket.svg" style="width: 26px" alt="" />
        <h3 class="mb-0" style="font-family: &quot;Rubik&quot;, serif">Editar búsqueda de tickets</h3>
      </ng-container>
    </div>
    <div>
      <button type="button" class="close btn-closed" aria-label="Close" (click)="close()">
        <span aria-hidden="true" style="font-size: 50px !important; font-weight: 100 !important">&times;</span>
      </button>
    </div>
  </div>

  <div
    *ngIf="componentResults && loadingData"
    class="loading-container d-flex flex-column align-items-center justify-content-center py-5 mt-3"
  >
    <div class="logo-loading mb-4">
      <img [src]="agencyImagen" alt="Logo" class="loading-logo animate__animated animate__pulse animate__infinite" />
    </div>

    <div class="text-center animate__animated animate__fadeIn">
      <h4 class="text-muted mb-3">Cargando información, gracias por esperar...</h4>

      <div
        [ngStyle]="{ color: getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
        class="spinner-border"
        role="status"
      ></div>
    </div>
  </div>

  <form *ngIf="!loadingData" (ngSubmit)="_onSubmit(_form, $event)" [formGroup]="_form" novalidate>
    <div class="d-flex mb-3 mt-3" style="gap: 1em">
      <div class="w-100" id="form-destination">
        <div class="position-relative">

            <input
              matInput
              placeholder="Destino"
              style="background-color: white"
              maxlength="20"
              name="destino"
              class="form-control input-search-box"
              autofocus
              #destination
              formControlName="destination"
              [matAutocomplete]="auto"
            />
            <mat-autocomplete
              class="mt-2"
              #auto="matAutocomplete"
              [displayWith]="displayFn"
              (optionSelected)="updateMySelection($event.option.value)"
            >
              <ng-container *ngIf="destinationOptions | async as options">
                <ng-container *ngFor="let item of options">
                  <ng-container *ngIf="item.type === 'city'">
                    <mat-option disabled style="background-color: #f4f4f4; height: 42px" *ngIf="options && options.length > 0">
                      <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center" style="gap: 0.25em">
                          <img src="../../../../assets/icons/search-box/ubicacion_gris.svg" style="width: 35px; height: 35px" />
                          <span
                            class="mt-1"
                            style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                            >Ubicación</span
                          >
                        </div>
                        <div>
                          <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                            >{{ item.cities.length }} resultados</span
                          >
                        </div>
                      </div>
                    </mat-option>
                    <ng-container *ngFor="let city of item.cities">
                      <mat-option [value]="city">
                        <div class="d-flex align-items-center" style="gap: 0.75em; margin-left: 9px">
                          <img src="{{ city.country_logo }}" style="width: 16px; height: 16px; border-radius: 50%" />
                          <p
                            class="mb-0"
                            style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                          >
                            {{ capitalize(city.city_name) }},
                            <span
                              class="mb-0"
                              style="
                                font-family: &quot;Rubik&quot;;
                                font-size: 12px !important;
                                line-height: 1;
                                font-weight: 400 !important;
                              "
                              >{{ capitalize(city.city_province) }}{{ city.city_province ? "," : "" }}
                              {{ capitalize(city.country_name) }}</span
                            >
                          </p>
                        </div>
                      </mat-option>
                    </ng-container>
                  </ng-container>
                </ng-container>

                <ng-container *ngFor="let item of options">
                  <ng-container *ngIf="item.type === 'hotel'">
                    <mat-option disabled style="background-color: #f4f4f4; height: 42px" *ngIf="item.hotels && item.hotels.length > 0">
                      <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center" style="gap: 0.25em">
                          <img src="../../../../assets/icons/search-box/hotel_gris.svg" style="width: 35px; height: 35px" />
                          <span
                            class="mt-1"
                            style="font-family: &quot;Rubik&quot;, serif; font-size: 13px !important; font-weight: 600 !important"
                            >Hotel</span
                          >
                        </div>
                        <div>
                          <span style="font-family: &quot;Rubik&quot;, serif; font-size: 11px !important; font-weight: 400 !important"
                            >{{ item.hotels.length }} resultados</span
                          >
                        </div>
                      </div>
                    </mat-option>
                    <ng-container *ngFor="let hotel of item.hotels">
                      <mat-option [value]="hotel">
                        <div style="margin-left: 2.4em">
                          <p
                            class="mb-0"
                            style="font-family: &quot;Rubik&quot;; font-size: 14px !important; font-weight: 600 !important; line-height: 1"
                          >
                            {{ capitalize(hotel.name) }},
                            <span
                              class="mb-0"
                              style="
                                font-family: &quot;Rubik&quot;;
                                font-size: 12px !important;
                                line-height: 1;
                                font-weight: 400 !important;
                              "
                            >
                              {{ capitalize(hotel.city_name) }}{{ hotel.city_name ? "," : "" }} {{ capitalize(hotel.city_province)
                              }}{{ hotel.city_province ? "," : "" }}
                              {{ capitalize(hotel.country_name) }}
                            </span>
                          </p>
                        </div>
                      </mat-option>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </mat-autocomplete>


          <span
            style="
              color: red;
              font-family: 'Poppins', sans-serif;
              font-size: 10px !important;
              line-height: 1;
              text-align: left;
              display: flex;
              margin-top: 5px;
            "
            *ngIf="_form.get('destination').touched && _form.get('destination').hasError('required')"
            >Este campo es requerido. Escriba y seleccione un destino válido de la lista.</span
          >
          <span
            style="
              color: red;
              font-family: 'Poppins', sans-serif;
              font-size: 10px !important;
              line-height: 1.2;
              text-align: left;
              display: flex;
              margin-top: 5px;
            "
            *ngIf="_form.get('destination').touched && _form.get('destination').hasError('invalidcountry')"
            >Formato de destino no válido. Seleccione un destino válido de la lista.</span
          >
          <span
            style="
              color: red;
              font-family: 'Poppins', sans-serif;
              font-size: 10px !important;
              line-height: 1.2;
              text-align: left;
              display: flex;
              margin-top: 5px;
            "
            *ngIf="_form.get('destination').touched && _form.get('destination').hasError('invalidDestination')"
            >Destino no válido, seleccione un destino válido de la lista.</span
          >
        </div>
      </div>

      <div style="width: 70%; position: relative" id="form-destination">
        <input
          type="text"
          #dateRangePicker
          formControlName="arrivalDateDepartureDate"
          autocomplete="off"
          class="form-control input-search-box"
          ngxDaterangepickerMd
          placeholder="  Check-in - check-out"
          [locale]="{ applyLabel: 'ok', format: 'DD/MM/YYYY' }"
          startKey="start"
          endKey="end"
          [autoApply]="true"
          [closeOnAutoApply]="true"
          [minDate]="minDate"
          [maxDate]="maxDate"
          (click)="openDatePicker()"
          (startDateChanged)="startDateClicked($event)"
          (endDateChanged)="endDateClicked($event)"
          readonly
          name="daterange"
        />
        <span
          style="
            color: red;
            font-family: 'Poppins', sans-serif;
            font-size: 10px !important;
            line-height: 1.2;
            text-align: left;
            display: flex;
            margin-top: 5px;
          "
          *ngIf="_form.get('arrivalDateDepartureDate').touched && _form.get('arrivalDateDepartureDate').hasError('required')"
          >Este campo es requerido.</span
        >
      </div>

      <div style="width: 70%; position: relative" id="form-destination">
        <button
          #triggerButton
          type="button"
          class="form-control btn-usb-rp d-flex align-items-center justify-content-between element-config-passenger"
          style="font-weight: 600"
          (click)="_openModal(); expandedConfigPassenger()"
          [attr.aria-expanded]="!isCollapsed"
          aria-controls="false"
        >
          <p
            class="p-0 m-0 align-self-center align-middle font-poppins text-passenger-input"
            style="font-weight: 600 !important; font-size: 14px"
          >
            {{ passengers }}
          </p>
          <img width="10" height="10" src="../../../../../assets/img/app/little-icons/arrow-down-black.svg" />
        </button>

        <div
          (collapsed)="clickOutside($event)"
          (expanded)="($event)"
          [collapse]="!isCollapsed || _close"
          (click)="_over()"
          class="config-passenger"
        >
          <div class="row">
            <div style="position: relative; width: 100%">
              <div
                #cardSelectorRoom
                id="cardSelectorRoom"
                class="card py-4 px-4 scrollable-card-container"
                style="width: auto !important; min-width: 100%"
              >
                <div class="room-content">
                  <div class="d-flex flex-row col-12 align-items-center justify-content-between p-2">
                    <div class="d-flex flex-column">
                      <div class="d-flex flex-row align-items-start justify-content-between p-0 pb-3">
                        <div class="d-flex flex-column">
                          <div class="d-flex flex-column">
                            <div style="line-height: 1">&nbsp;</div>
                            <div style="line-height: 1">&nbsp;</div>
                          </div>
                          <div
                            class="mr-2"
                            style="padding: 28px 0 0 0; font-family: &quot;Rubik&quot;; font-size: 14px; font-weight: 500; width: 70px"
                          >
                            Pasajeros
                          </div>
                        </div>
                        <div class="d-flex flex-column align-items-center p-0 m-0 mr-2 ml-3">
                          <div class="d-flex flex-column align-items-start mb-3">
                            <label
                              class="mb-0"
                              style="
                                font-family: &quot;Rubik&quot; !important;
                                font-size: 14px !important;
                                font-weight: 600 !important;
                                line-height: 1;
                              "
                              for="adults"
                              >Adultos</label
                            >
                            <p
                              class="mb-0"
                              style="
                                font-family: &quot;Rubik&quot; !important;
                                font-size: 11px !important;
                                font-weight: 400 !important;
                                line-height: 1;
                              "
                            >
                              + de 18 años
                            </p>
                          </div>
                          <div class="input-group justify-content-end" style="max-width: 200px; width: 100%; min-width: 91px">
                            <button
                              type="button"
                              class="pr-2"
                              style="border: none; background-color: transparent"
                              (click)="decrementPassengerAdult($event)"
                              [disabled]="getPassengerCountAdult() <= 1"
                            >
                              <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">-</p>
                            </button>

                            <input
                              type="number"
                              class="form-control text-center"
                              style="border-radius: 8px; max-width: 45px; padding: 0 !important"
                              [value]="getPassengerCountAdult()"
                              [min]="1"
                              [max]="10"
                              (change)="validatePassengerInput($event)"
                              (keydown)="handleAdultInput($event)"
                              (blur)="handleAdultBlur($event)"
                              (click)="preventModalClose($event)"
                              name="adults"
                            />

                            <button
                              type="button"
                              class="pl-2"
                              style="border: none; background-color: transparent"
                              (click)="incrementPassengerAdult($event)"
                              [disabled]="getPassengerCountAdult() >= 10"
                            >
                              <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">+</p>
                            </button>
                          </div>
                        </div>
                        <div class="d-flex flex-column align-items-center p-0 m-0 mr-3 ml-2">
                          <div class="container-label d-flex mb-3">
                            <div class="d-flex flex-column align-items-start">
                              <div class="d-flex" style="line-height: 1">
                                <label
                                  class="mb-0"
                                  style="
                                    font-family: &quot;Rubik&quot; !important;
                                    font-size: 14px !important;
                                    font-weight: 600 !important;
                                    line-height: 1;
                                  "
                                  for="childs"
                                  >Niños</label
                                >
                                <div class="info-tool d-flex flex-column position-relative">
                                  <img #iconInfo src="../../../../../assets/icons/search-box/Informativo-01.svg" width="13px" alt="" />
                                  <span class="tooltip-info">Los bebes (0 - 2 años sin cumplir) deben indicarse como niños</span>
                                </div>
                              </div>
                              <p
                                class="mb-0"
                                style="
                                  font-family: &quot;Rubik&quot; !important;
                                  font-size: 11px !important;
                                  font-weight: 400 !important;
                                  line-height: 1;
                                "
                              >
                                - de 18 años
                              </p>
                            </div>
                          </div>
                          <div class="input-group justify-content-end" style="max-width: 200px; width: 100%; min-width: 91px">
                            <button
                              type="button"
                              style="border: none; background-color: transparent"
                              class="pr-2"
                              (click)="decrementPassengerChildren($event)"
                              [disabled]="getPassengerCountChildren() <= 0"
                            >
                              <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">-</p>
                            </button>

                            <input
                              type="number"
                              class="form-control text-center"
                              style="border-radius: 8px; max-width: 45px; padding: 0 !important"
                              [value]="getPassengerCountChildren()"
                              [min]="0"
                              [max]="10"
                              (change)="validatePassengerInput($event)"
                              (keydown)="handleChildrenInput($event)"
                              (blur)="handleChildrenBlur($event)"
                              (click)="preventModalClose($event)"
                              name="children"
                            />

                            <button
                              type="button"
                              style="border: none; background-color: transparent"
                              class="pl-2"
                              (click)="incrementPassengerChildren($event)"
                              [disabled]="getPassengerCountChildren() >= 10"
                            >
                              <p class="mb-0" style="font-size: 20px; font-weight: 700 !important">+</p>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        *ngIf="formArray(_form, 'childsage').length > 0"
                        class="d-flex flex-column p-4 m-0"
                        style="border-radius: 10px; background-color: #f4f4f4"
                      >
                        <div class="d-flex flex-column align-items-start mb-3 ml-1">
                          <label
                            class="mb-0"
                            style="
                              font-family: &quot;Rubik&quot; !important;
                              font-size: 14px !important;
                              font-weight: 600 !important;
                              line-height: 1;
                              text-wrap: nowrap;
                            "
                            for="adults"
                            >Edad niños <span style="font-weight: 400 !important">- de 18 años</span></label
                          >
                        </div>

                        <div class="d-flex mb-4">
                          <div formArrayName="childsage" *ngFor="let age of formArray(_form, 'childsage'); let j = index">
                            <div *ngIf="j >= 0 && j <= 3">
                              <label [formGroupName]="j" class="p-0 ml-1" style="position: relative">
                                <select
                                  name="age"
                                  id="age"
                                  formControlName="age"
                                  [ngStyle]="{ 'margin-left': j > 0 ? '1em' : '' }"
                                  class="form-control custom-select-arrow"
                                  style="
                                    height: 35px !important;
                                    padding: 0 !important;
                                    width: 60px !important;
                                    font-family: &quot;Rubik&quot; !important;
                                    font-size: 14px !important;
                                    font-weight: 600 !important;
                                    text-align: left;
                                    padding-left: 13px !important;
                                    background-color: #FFFFFF !important;
                                    border-radius: 12px;
                                  "
                                >
                                  <ng-container *ngFor="let value of agesChildsArr()">
                                    <option value="{{ value }}">{{ value }}</option>
                                  </ng-container>
                                </select>
                                <span
                                  style="
                                    position: absolute;
                                    top: 42%;
                                    right: 0.7em;
                                    width: 0;
                                    height: 0;
                                    border-left: 4px solid transparent;
                                    border-right: 4px solid transparent;
                                  "
                                  [ngStyle]="{
                                    'border-top': '6px solid ' + getClientsSettingAppBooking?.clients_setting_global?.color_main_1
                                  }"
                                ></span>
                              </label>
                            </div>
                          </div>
                        </div>

                        <div class="d-flex mb-4">
                          <div formArrayName="childsage" *ngFor="let age of formArray(_form, 'childsage'); let j = index">
                            <div *ngIf="j >= 4 && j <= 7">
                              <div [formGroupName]="j" class="p-0 ml-1" style="position: relative">
                                <select
                                  name="age"
                                  id="age"
                                  formControlName="age"
                                  [ngStyle]="{ 'margin-left': j > 4 ? '1em' : '' }"
                                  class="form-control custom-select-arrow"
                                  style="
                                    height: 35px !important;
                                    padding: 0 !important;
                                    width: 60px !important;
                                    font-family: &quot;Rubik&quot; !important;
                                    font-size: 14px !important;
                                    font-weight: 600 !important;
                                    text-align: left;
                                    padding-left: 13px !important;
                                    background-color: #FFFFFF !important;
                                    border-radius: 12px;
                                  "
                                >
                                  <ng-container *ngFor="let value of agesChildsArr()">
                                    <option value="{{ value }}">{{ value }}</option>
                                  </ng-container>
                                </select>
                                <span
                                  style="
                                    position: absolute;
                                    top: 42%;
                                    right: 0.7em;
                                    width: 0;
                                    height: 0;
                                    border-left: 4px solid transparent;
                                    border-right: 4px solid transparent;
                                  "
                                  [ngStyle]="{
                                    'border-top': '6px solid ' + getClientsSettingAppBooking?.clients_setting_global?.color_main_1
                                  }"
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="d-flex">
                          <div formArrayName="childsage" *ngFor="let age of formArray(_form, 'childsage'); let j = index">
                            <div *ngIf="j >= 8 && j <= 9">
                              <div [formGroupName]="j" class="p-0 ml-1" style="position: relative">
                                <select
                                  name="age"
                                  id="age"
                                  formControlName="age"
                                  [ngStyle]="{ 'margin-left': j === 9 ? '1em' : '' }"
                                  class="form-control custom-select-arrow"
                                  style="
                                    height: 35px !important;
                                    padding: 0 !important;
                                    width: 60px !important;
                                    text-align: center;
                                    font-family: &quot;Rubik&quot; !important;
                                    font-size: 14px !important;
                                    font-weight: 600 !important;
                                  "
                                >
                                  <ng-container *ngFor="let value of agesChildsArr()">
                                    <option value="{{ value }}">{{ value }}</option>
                                  </ng-container>
                                </select>
                                <span
                                  style="
                                    position: absolute;
                                    top: 42%;
                                    right: 0.7em;
                                    width: 0;
                                    height: 0;
                                    border-left: 4px solid transparent;
                                    border-right: 4px solid transparent;
                                  "
                                  [ngStyle]="{
                                    'border-top': '6px solid ' + getClientsSettingAppBooking?.clients_setting_global?.color_main_1
                                  }"
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-row justify-content-end py-2">
                        <div class="py-2 justify-content-end">
                          <button
                            (click)="_confirm()"
                            [attr.aria-expanded]="!isCollapsed"
                            aria-controls="false"
                            class="badge btn-choice-confirm"
                            style="border: none; min-width: 145px; width: 100%; height: 36px"
                            type="button"
                            [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
                          >
                            Confirmar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="width: 70%" id="form-destination">
        <!-- btn-usblick -->
        <button
          *ngIf="userService.itineraryActive.length == 0"
          class="btn btn-search-hotel d-flex justify-content-center align-items-center inp w-100"
          [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
          type="submit"
        >
          <span style="font-weight: 600 !important; text-transform: uppercase;">BUSCAR</span>
        </button>
        <button
          *ngIf="userService.itineraryActive.length > 0"
          class="btn btn-search-hotel d-flex justify-content-center align-items-center inp w-100"
          [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
          type="submit"
        >
          <span style="font-weight: 600 !important; text-transform: uppercase;">BUSCAR</span>
        </button>
      </div>
    </div>
  </form>
</div>

<div class="modal" [ngClass]="{ show: showModal }">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title mt-2 text-black">{{ titleModal }}</h5>
      </div>
      <div class="modal-body">
        <p class="mb-1 text-black">{{ messageModal }}</p>
      </div>
      <div class="d-flex flex-end justify-content-end mr-3 mb-4">
        <button
          type="button"
          class="btn-confirm-modal rounded-pill"
          [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
          (click)="confirmAction()"
        >
          ACEPTAR
        </button>
      </div>
    </div>
  </div>
</div>
